export enum SchoolLevelEnum {
  CE2 = 'CE2',
  CM1 = 'CM1',
  CM2 = 'CM2',
  SIXIEME = 'SIXIEME',
  CINQUIEME = 'CINQUIEME',
  QUATRIEME = 'QUATRIEME',
  TROISIEME = 'TROISIEME',
  SECONDE = 'SECONDE',
  PREMIERE = 'PREMIERE',
  TERMINALE = 'TERMINALE',
  UNIVERSITY = 'UNIVERSITY'
}

export const schoolLevelEnumMapping: Record<SchoolLevelEnum, string> = {
  CE2: 'CE2',
  CM1: 'CM1',
  CM2: 'CM2',
  SIXIEME: '6ème',
  CINQUIEME: '5ème',
  QUATRIEME: '4ème',
  TROISIEME: '3ème',
  SECONDE: 'Seconde',
  PREMIERE: '1ère',
  TERMINALE: 'Terminale',
  UNIVERSITY: 'Etude Sup'
}
